import { combineReducers } from 'redux'
import UploadFile from './uploadFile/uploadFile.reducer'
import user from './slice/user';
import socketSlice from './slice/socketSlice';
import notificationSlice from './slice/notificationSlice';
const rootReducer = combineReducers({
  UploadFile,
  user,
  socketSlice,
  notificationSlice,
})

export default rootReducer
